function NumberButton({ children, onClick, color, className, ...props }) {
    return (
        <button
            type="button"
            aria-label="number icon"
            onClick={() => onClick?.()}
            className={`flex items-center justify-center w-10 h-10 font-semibold text-white rounded-md ${color} ${className}`}
            {...props}
        >
            {children}
        </button>
    );
}

export default NumberButton;
